import { NAMES_ES } from "../../assets/appConstants/constants";
import CopyToClipboard from "../common/CopyToClipboard";
import { TableColumn } from "../../models/dataTable.model";
import { DataTicket } from "../../models/ticket.model";
import { Link } from "react-router-dom";
import { getPriorityColor } from "../../utilities/functions";
import './index.css'


const TableSchema: TableColumn[] = [
  { key: 'number', name: NAMES_ES.number, width: '11%' },
  { key: 'date', name: NAMES_ES.opening_date, width: '11%' },
  { key: 'title_name', name: NAMES_ES.title, width: '9%' },
  { key: 'element_name', name: NAMES_ES.element, width: '10%' },
  { key: 'status_name', name: NAMES_ES.status, width: '10%' },
  { key: 'priority_name', name: NAMES_ES.priority, width: '9%' },
  { key: 'priority_code', name: '', width: '0%', hidden: true },
  { key: 'company_name', name: NAMES_ES.company, width: '10%' },
  { key: 'alarms', name: NAMES_ES.alarms, width: '9%' },
  { key: 'technician', name: NAMES_ES.technician, width: '9%' },
  { key: 'last_update_date', name: NAMES_ES.last_updated_date, width: '12%' },
]

const columnId: string = 'number'
const rowDetailPath = '/ticket/view/'

const rowDataPreprocesor = (rowData: DataTicket): any => {

  return {
    ...rowData,
    number_render: (
      <div className='tickets-table-column-number'>
        <span>
          <Link className="tickets-table-column-number__link" to={`/${rowData.project_code}${rowDetailPath}${rowData.number}/0`}>
            {rowData.number}
          </Link>
        </span>

        <div className='tickets-table-column-number__copyicon'>
          <CopyToClipboard targetText={rowData.number as string} />
        </div>
      </div>
    ),
    priority_name_render: (
      <div className="tickets-table-column-priority"
        style={{ backgroundColor: getPriorityColor(rowData.priority_code ?? '') }}
      >
        {rowData.priority_name}
      </div>
    ),
    technician_render: rowData.technician.label
  }
}

const handleDoubleClickRow = (rowData: DataTicket, navigate: any) => {
  navigate(`/${rowData.project_code}${rowDetailPath}${rowData.number}/0`)
}

export { TableSchema, columnId, rowDataPreprocesor, handleDoubleClickRow }